import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -8,
      marginLeft: -12,
    },
  }));
